// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8b4a9adb","278":"42bc5cdb","487":"2735c6b1","787":"fec03637"}[chunkId] + ".chunk.js";
};